import { SearchFormFields } from '@awaze/design-system.compositions.search-form'
import type { SearchCriteria } from '@awaze/mfe-common.types-and-mocks.site-search-service'
import parse from 'date-fns/parse'

import { DEFAULT_SEARCH_LOCATION_URL } from 'src/constants'
import { environment, FUSION_DATE_FORMAT } from './SearchForm.types'

const getNewAgeURL = (params: string) => `/search?${params}`

const getFusionURL = (params: string, destinationURL: string) => {
  const destinationParams = destinationURL ? destinationURL.split('?') : []

  const rhs1Location = destinationParams[0]
    ? destinationParams[0]
    : DEFAULT_SEARCH_LOCATION_URL

  const rhs2QueryParam =
    destinationParams.length > 1 ? '&' + destinationParams.pop() : ''

  return `${rhs1Location}?${params}${rhs2QueryParam}`
}

export const buildURL = (
  params: string,
  destinationURL: string,
  platform: string,
): string =>
  platform === 'new-age'
    ? getNewAgeURL(params)
    : getFusionURL(params, destinationURL)

export const getUrlForEnv = (environment: environment): string => {
  return (
    process.env.NEXT_PUBLIC_LOCATION_API_URL ??
    process.env.LOCATION_API_URL ??
    `https://location-lookup.api.${environment}.age.awaze.com`
  )
}

export const mapSearchCriteriaToInitialValues = (
  searchCriteria: SearchCriteria,
): SearchFormFields => {
  const {
    adult,
    child,
    destinationURL,
    infant = 0,
    nights,
    pets,
    range,
    regionName,
    start,
  } = searchCriteria

  return {
    adult,
    child,
    destination: regionName,
    destinationURL,
    infant,
    nights,
    pets,
    range,
    ...(start && {
      start: parse(start, FUSION_DATE_FORMAT, new Date()),
    }),
  }
}

export const resolvePlacesId = (
  id: string,
  placesId: string,
  destination: string,
): string | undefined => {
  // id ONLY exists if a destination selection has been made in the Search-Form
  if (id) {
    return id
  }

  // Persist PlacesID from query string if it exists
  if (destination && placesId) {
    return placesId
  }

  return undefined
}

type FormatAutocompleteSubtitleProps = {
  name: string
  subtitle?: string
  parentName?: string
  countryName?: string
  type?: string
}
export const formatAutocompleteSubtitle = (
  location: FormatAutocompleteSubtitleProps,
): string => {
  if (location.subtitle) return location.subtitle
  if (location.countryName == location.name) return ''
  if (location.parentName == location.countryName)
    return location.countryName ?? ''

  if (location?.parentName && location?.countryName)
    return `${location?.parentName}, ${location?.countryName}`
  return ''
}

export const resolveRadiusCentre = (
  radiusCentre: string | null,
  id: string,
  placesId: string,
  destinationId: string,
  queryRadiusCentre: string | null,
): string | null => {
  // Use radiusCentre from the Google-Places-API
  if (radiusCentre) {
    return radiusCentre
  }

  // Or persist radiusCentre from query string if no other location has been selected
  return !id && !placesId && !destinationId && queryRadiusCentre
    ? queryRadiusCentre
    : null
}
